import { RootState } from '../../../stores/types';
import { OptinState } from '../types';

export default (state: RootState): OptinState => state.optin;
